// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-modal {
  font-size: 14px;
  max-width: 1000px;
}
.about-modal .body {
  overflow: auto;
  padding: 25px;
}
.about-modal .menu {
  position: sticky;
  top: 0;
}
.about-modal .column {
  max-width: 500px;
}
.about-modal h1 {
  font-size: 2em;
}
.about-modal h2 {
  font-size: 1.2em;
}
.about-modal h3 {
  font-size: 1em;
}
.about-modal h1,
.about-modal h2,
.about-modal h3 {
  width: 100%;
  text-align: left;
  font-weight: 400;
  line-height: 1em;
  margin-bottom: 0.5em;
}
.about-modal p,
.about-modal li {
  text-align: left;
  font-family: "Noto Sans", sans-serif;
  font-size: 1em;
  line-height: 1.5em;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.about-modal p.lead,
.about-modal li.lead {
  font-style: italic;
}
.about-modal p {
  margin-bottom: 1em;
}
.about-modal .card#example {
  font-size: 0.8em;
}
.about-modal ol li {
  counter-increment: list;
  padding-left: 7px;
  margin-bottom: 7px;
}
.about-modal ol li:before {
  content: counter(list) ". ";
  margin-left: -7px;
  margin-right: 2px;
}
.about-modal ol li li {
  counter-increment: sublist;
}
.about-modal ol li li:before {
  content: counter(sublist) " - ";
  margin-left: 0px;
  margin-right: 2px;
}
.about-modal .block {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 0.5em;
  margin-top: 0.5em;
}
.about-modal .block .sub-block {
  position: relative;
  background-color: #fff;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 0.5em;
  margin-top: 0.5em;
}
.about-modal .block .sub-block h4 {
  margin-bottom: 0.25em;
}
.about-modal .block .sub-block p {
  margin-top: 0.125em;
  margin-bottom: 0;
}
.about-modal .block .sub-block.arrow.top:after {
  content: " ";
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 10px;
  height: 10px;
  position: absolute;
  border: 15px solid rgba(0, 0, 0, 0);
  border-left-color: rgb(255, 255, 255);
  right: -30px;
  top: 15px;
}
@media screen and (max-width: 720px) {
  .about-modal .block .sub-block.arrow.top:after {
    border-top-color: rgb(255, 255, 255);
    right: 50%;
    bottom: -30px;
    top: auto;
    border-left-color: transparent;
  }
}
.about-modal .block .sub-block.arrow.bottom:after {
  content: " ";
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 10px;
  height: 10px;
  position: absolute;
  border: 15px solid rgba(0, 0, 0, 0);
  border-left-color: rgb(255, 255, 255);
  right: -30px;
  bottom: 15px;
}
@media screen and (max-width: 720px) {
  .about-modal .block .sub-block.arrow.bottom:after {
    border-bottom-color: rgb(255, 255, 255);
    right: 50%;
    top: -30px;
    bottom: auto;
    border-left-color: transparent;
  }
}
.about-modal .block.card-block {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.about-modal .block.card-block > :nth-child(1) {
  grid-area: 1/1/2/2;
}
.about-modal .block.card-block > :nth-child(3) {
  grid-area: 2/1/3/2;
}
.about-modal .block.card-block > :nth-child(2) {
  grid-area: 1/2/3/3;
  margin: 0 auto;
}
@media screen and (max-width: 720px) {
  .about-modal .block.card-block {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }
}
.about-modal .block.card-block nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin: 0 auto;
}
.about-modal .block.card-block nav .btn {
  display: inline-block;
  margin: 15px 10px;
  border-radius: 4px;
  padding: 5px 10px;
  border-width: 1px;
  cursor: pointer;
  background: #ebebeb;
}
.about-modal .block.card-block nav .btn:hover {
  background: #dcdcdc;
}
.about-modal .block.card-block nav span.item {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: 10px;
  height: 10px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.about-modal .block.card-block nav span.item.current {
  font-size: 1.5em;
  font-weight: bold;
}
.about-modal strong {
  font-weight: bolder;
}
.about-modal p + h2,
.about-modal ol + h2 {
  margin-top: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modalAbout.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;AACF;AACE;EACE,cAAA;EACA,aAAA;AACJ;AAEE;EACE,gBAAA;EACA,MAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAOE;;;EAGE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AALJ;AAQE;;EAEE,gBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,WAAA;EACA,8BAAA;UAAA,sBAAA;AANJ;AAQI;;EACE,kBAAA;AALN;AASE;EACE,kBAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;AAYI;EACE,uBAAA;EACA,iBAAA;EACA,kBAAA;AAVN;AAYM;EACE,2BAAA;EACA,iBAAA;EACA,iBAAA;AAVR;AAaM;EACE,0BAAA;AAXR;AAaQ;EACE,+BAAA;EACA,gBAAA;EACA,iBAAA;AAXV;AAiBE;EACE,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;AAfN;AAiBM;EACE,qBAAA;AAfR;AAiBM;EACE,mBAAA;EACA,gBAAA;AAfR;AAmBQ;EACE,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,qCAAA;EACA,YAAA;EACA,SAAA;AAjBV;AAmBU;EAXF;IAYI,oCAAA;IACA,UAAA;IACA,aAAA;IACA,SAAA;IACA,8BAAA;EAhBV;AACF;AAmBQ;EACE,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,qCAAA;EACA,YAAA;EACA,YAAA;AAjBV;AAmBU;EAXF;IAYI,uCAAA;IACA,UAAA;IACA,UAAA;IACA,YAAA;IACA,8BAAA;EAhBV;AACF;AAqBI;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;UAAA,sBAAA;AAnBN;AAqBM;EACE,kBAAA;AAnBR;AAqBM;EACE,kBAAA;AAnBR;AAqBM;EACE,kBAAA;EACA,cAAA;AAnBR;AAsBM;EApBF;IAqBI,oBAAA;IAAA,oBAAA;IAAA,aAAA;IACA,4BAAA;IAAA,6BAAA;QAAA,0BAAA;YAAA,sBAAA;EAnBN;AACF;AAqBM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,cAAA;AAnBR;AAqBQ;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAnBV;AAqBU;EACE,mBAAA;AAnBZ;AAuBQ;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AArBV;AAuBU;EACE,gBAAA;EACA,iBAAA;AArBZ;AA4BE;EACE,mBAAA;AA1BJ;AA6BE;;EAEE,iBAAA;AA3BJ","sourcesContent":[".about-modal {\n  font-size: 14px;\n  max-width: 1000px;\n\n  .body {\n    overflow: auto;\n    padding: 25px;\n  }\n\n  .menu {\n    position: sticky;\n    top: 0;\n  }\n\n  .column {\n    max-width: 500px;\n  }\n\n  h1 {\n    font-size: 2em;\n  }\n\n  h2 {\n    font-size: 1.2em;\n  }\n\n  h3 {\n    font-size: 1em;\n  }\n\n  h1,\n  h2,\n  h3 {\n    width: 100%;\n    text-align: left;\n    font-weight: 400;\n    line-height: 1em;\n    margin-bottom: 0.5em;\n  }\n\n  p,\n  li {\n    text-align: left;\n    font-family: 'Noto Sans', sans-serif;\n    font-size: 1em;\n    line-height: 1.5em;\n    flex: 1;\n    width: 100%;\n    box-sizing: border-box;\n\n    &.lead {\n      font-style: italic;\n    }\n  }\n\n  p {\n    margin-bottom: 1em;\n  }\n\n  .card#example {\n    font-size: 0.8em;\n  }\n\n  ol {\n    li {\n      counter-increment: list;\n      padding-left: 7px;\n      margin-bottom: 7px;\n\n      &:before {\n        content: counter(list) '. ';\n        margin-left: -7px;\n        margin-right: 2px;\n      }\n\n      li {\n        counter-increment: sublist;\n\n        &:before {\n          content: counter(sublist) ' - ';\n          margin-left: -0px;\n          margin-right: 2px;\n        }\n      }\n    }\n  }\n\n  .block {\n    background-color: rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    padding: 14px;\n    margin-bottom: 0.5em;\n    margin-top: 0.5em;\n\n    .sub-block {\n      position: relative;\n      background-color: #fff;\n      border-radius: 10px;\n      padding: 14px;\n      margin-bottom: 0.5em;\n      margin-top: 0.5em;\n\n      h4 {\n        margin-bottom: 0.25em;\n      }\n      p {\n        margin-top: 0.125em;\n        margin-bottom: 0;\n      }\n\n      &.arrow {\n        &.top:after {\n          content: ' ';\n          box-sizing: border-box;\n          width: 10px;\n          height: 10px;\n          position: absolute;\n          border: 15px solid rgb(0 0 0 / 0%);\n          border-left-color: rgb(255 255 255);\n          right: -30px;\n          top: 15px;\n\n          @media screen and (max-width: 720px) {\n            border-top-color: rgb(255, 255, 255);\n            right: 50%;\n            bottom: -30px;\n            top: auto;\n            border-left-color: transparent;\n          }\n        }\n\n        &.bottom:after {\n          content: ' ';\n          box-sizing: border-box;\n          width: 10px;\n          height: 10px;\n          position: absolute;\n          border: 15px solid rgb(0 0 0 / 0%);\n          border-left-color: rgb(255 255 255);\n          right: -30px;\n          bottom: 15px;\n\n          @media screen and (max-width: 720px) {\n            border-bottom-color: rgb(255, 255, 255);\n            right: 50%;\n            top: -30px;\n            bottom: auto;\n            border-left-color: transparent;\n          }\n        }\n      }\n    }\n\n    &.card-block {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-template-rows: repeat(2, 1fr);\n      grid-column-gap: 0px;\n      grid-row-gap: 0px;\n      width: 100%;\n      box-sizing: border-box;\n\n      & > :nth-child(1) {\n        grid-area: 1 / 1 / 2 / 2;\n      }\n      & > :nth-child(3) {\n        grid-area: 2 / 1 / 3 / 2;\n      }\n      & > :nth-child(2) {\n        grid-area: 1 / 2 / 3 / 3;\n        margin: 0 auto;\n      }\n\n      @media screen and (max-width: 720px) {\n        display: flex;\n        flex-direction: column;\n      }\n\n      nav {\n        display: flex;\n        align-items: center;\n        margin: 0 auto;\n\n        .btn {\n          display: inline-block;\n          margin: 15px 10px;\n          border-radius: 4px;\n          padding: 5px 10px;\n          border-width: 1px;\n          cursor: pointer;\n          background: #ebebeb;\n\n          &:hover {\n            background: #dcdcdc;\n          }\n        }\n\n        span.item {\n          display: inline-flex;\n          width: 10px;\n          height: 10px;\n          justify-content: center;\n          align-items: center;\n\n          &.current {\n            font-size: 1.5em;\n            font-weight: bold;\n          }\n        }\n      }\n    }\n  }\n\n  strong {\n    font-weight: bolder;\n  }\n\n  p + h2,\n  ol + h2 {\n    margin-top: 1.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
